export default "__VITE_ASSET__DRNl41dO__"